import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPreguntaActiva, setRespuesta } from "../actions";

// 1. Importamos Spinner y Alert
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Spinner,
  Alert,
} from "react-bootstrap";

import { Instrumento } from "./Instrumento";
import check from "../img/check-svgrepo-com.svg";

// 2. Función de Aleatoriedad
const obtenerSiguientePregunta = (todasLasPreguntas, respuestasActuales) => {
  const preguntasPendientes = todasLasPreguntas.filter(
    (pregunta) =>
      !respuestasActuales.some((r) => r.id_pregunta === pregunta.id_pregunta)
  );
  if (preguntasPendientes.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * preguntasPendientes.length);
  return preguntasPendientes[randomIndex].id_pregunta;
};

const Pregunta203 = (props) => {
  const dispatch = useDispatch();

  // 3. Estados de carga y error
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [values, setValues] = useState({
    usted: 0,
    colegas: 0,
    range01: 4,
    range02: 4,
    range03: 4,
    range04: 4,
    range05: 4,
    range06: 4,
    range07: 4,
    range08: 4,
    range09: 4,
    range10: 4,
  });

  const [submitted, setSubmitted] = useState(false);

  const preguntaActiva = useSelector((state) => state.preguntaActiva);
  const ticket = useSelector((state) => state.ticket);

  const handleInputChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
    if (errorMsg) setErrorMsg("");
  };

  const HandleClickVolver = () => {
    dispatch(
      setPreguntaActiva({
        id_instrumento: 0,
        id_pregunta: 0,
        contador: 0,
        pregunta_anterior: 0,
        respuesta_anterior: 0,
        // respuestas203 NO se limpia aquí: Inicio lo usa como indicador "Finalizado".
        // El reinicio del historial ocurre al (re)entrar al Test 3 (Inicio.handleClick).
      })
    );
    setValues((values) => ({ ...values }));
  };

  if (preguntaActiva.id_instrumento === 0)
    return <Navigate to="/inicio" replace={true} />;

  // 4. LOGICA SIGUIENTE (ASYNC + RANDOM + RESPUESTAS203)
  const HandleClickSiguiente = async () => {
    setIsSaving(true);
    setErrorMsg("");

    try {
      // A. Construcción de respuesta especial (Matriz pregunta 20305)
      let _texto = "";
      // Nota: Usamos el ID de la pregunta activa para detectar si es la matriz
      if (preguntaActiva.id_pregunta === 20305) {
        _texto = JSON.stringify({
          range01: values.range01,
          range02: values.range02,
          range03: values.range03,
          range04: values.range04,
          range05: values.range05,
          range06: values.range06,
          range07: values.range07,
          range08: values.range08,
          range09: values.range09,
          range10: values.range10,
        });
      }

      // B. Preparar datos API
      const _props = {
        token: "c3649ba4e3a81815",
        function: "SetRespuesta",
        params: {
          ticket: ticket.Ticket,
          id_proceso: 1,
          id_usuario: ticket.id_usuario,
          id_pregunta: preguntaActiva.id_pregunta,
          respuesta: values.usted,
          respuesta_texto: _texto,
          respuesta_2: values.colegas,
          respuesta_texto_2: "",
          respuesta_3: 0,
          respuesta_texto_3: "",
        },
      };

      // C. Enviar a API (Await)
      await dispatch(setRespuesta(_props));

      // D. Actualizar Historial Local (respuestas203)
      // Creamos un objeto de respuesta para el historial local
      const _respuestaLocal = {
        id_pregunta: preguntaActiva.id_pregunta,
        respuesta: values.usted,
        // Guardamos el texto también por si se necesita, aunque para el random solo importa el ID
        respuesta_texto: _texto,
      };

      const currentRespuestas = preguntaActiva.respuestas203 || [];
      const existingIndex = currentRespuestas.findIndex(
        (item) => item.id_pregunta === _respuestaLocal.id_pregunta
      );

      let updatedRespuestas;
      if (existingIndex >= 0) {
        updatedRespuestas = currentRespuestas.map((item, index) =>
          item.id_pregunta === _respuestaLocal.id_pregunta
            ? { ...item, ..._respuestaLocal }
            : item
        );
      } else {
        updatedRespuestas = [...currentRespuestas, _respuestaLocal];
      }

      // E. Calcular Siguiente ID (Random)
      const _instrumento = Instrumento.find((element) => {
        return element.id_instrumento === preguntaActiva.id_instrumento;
      });

      const idSiguiente = obtenerSiguientePregunta(
        _instrumento.preguntas,
        updatedRespuestas
      );

      const nextId =
        idSiguiente !== null ? idSiguiente : preguntaActiva.id_pregunta;

      // F. Actualizar Redux
      dispatch(
        setPreguntaActiva({
          id_instrumento: preguntaActiva.id_instrumento,
          id_pregunta: nextId,
          contador: preguntaActiva.contador + 1,
          pregunta_anterior: preguntaActiva.id_pregunta,
          respuesta_anterior: values.usted,
          respuestas203: updatedRespuestas, // Guardamos en la variable solicitada
        })
      );

      // G. Resetear valores
      setValues((values) => ({
        ...values,
        usted: 0,
        colegas: 0,
        // Rangos vuelven al centro (4 = "Yo soy igual al resto"), valor por defecto neutro de la matriz
        range01: 4,
        range02: 4,
        range03: 4,
        range04: 4,
        range05: 4,
        range06: 4,
        range07: 4,
        range08: 4,
        range09: 4,
        range10: 4,
      }));
    } catch (error) {
      console.error(error);
      setErrorMsg("Error al guardar respuesta. Intente nuevamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const HandleClick1 = (val) => {
    setValues((values) => ({
      ...values,
      usted: val,
    }));
    if (errorMsg) setErrorMsg("");
  };

  const HandleClick2 = (val) => {
    setValues((values) => ({
      ...values,
      colegas: val,
    }));
  };

  const _instrumento = Instrumento.find((element) => {
    return element.id_instrumento === preguntaActiva.id_instrumento;
  });

  const _preg = _instrumento?.preguntas.find((element) => {
    return element.id_pregunta === preguntaActiva.id_pregunta;
  });

  // FIN DEL TEST
  if (_instrumento.total_preguntas < preguntaActiva.contador || !_preg)
    return (
      <Container>
        <h1 className="mt-4">Fin de Test</h1>
        <hr />
        <Row>
          <Col>
            <p className="xz-texto-v ">Has finalizado este test.</p>
            <p className="xz-texto-v ">Sigue adelante !</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className="xz-btn-pregunta" onClick={HandleClickVolver}>
              Volver al Inicio
            </Button>
          </Col>
        </Row>
      </Container>
    );

  const es_un_check_usted = (i) => {
    if (values.usted === i) return <img alt="" src={check} width="50" />;
  };

  // BOTÓN CON SPINNER
  const avanzar_siguiente = () => {
    if (
      (_preg.id_correlativo >= 1 &&
        _preg.id_correlativo <= 4 &&
        values.usted > 0) ||
      _preg.id_correlativo === 5 // Matriz: sliders inician en 4, el botón siempre disponible
    ) {
      return (
        <Col className="text-end">
          <Button onClick={HandleClickSiguiente} disabled={isSaving}>
            {isSaving ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                Guardando...
              </>
            ) : (
              "Avanzar a Siguiente Pregunta"
            )}
          </Button>
        </Col>
      );
    }
  };

  const pregunta_2_alternativa = () => {
    return (
      <Row>
        <hr />
        <p className="xz-texto-instruccion ">
          A continuación de la pregunta 1 a la 4, señale la alternativa que
          mejor describe lo que usted considera
        </p>
        <Col className="col-12 col-sm-6 xz-pregunta1">
          <p className="">{_preg.texto}</p>
        </Col>
        <Col>
          <Row>
            <Col className="ms-5 mb-5 xz-texto-instruccion">
              <p></p>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(1)}
              >
                {es_un_check_usted(1)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt1}</p>
            </Col>
          </Row>
          <Row>
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(2)}
              >
                {es_un_check_usted(2)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt2}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const pregunta_3_alternativa = () => {
    return (
      <Row>
        <h5></h5>
        <Col className="col-12 col-sm-6 xz-pregunta1">
          <p className="">{_preg.texto}</p>
        </Col>
        <Col>
          <Row>
            <Col className="ms-5 mb-5 xz-texto-instruccion">
              <p>
                Señale la alternativa que mejor describe lo que usted haría al
                buscar información en internet.
                <strong> Preguntaría...</strong>
              </p>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(1)}
              >
                {es_un_check_usted(1)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt1}</p>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(2)}
              >
                {es_un_check_usted(2)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt2}</p>
            </Col>
          </Row>
          <Row>
            <Col className="col-4 d-flex justify-content-end">
              <Button
                className="xz-btn-pregunta-3"
                onClick={() => HandleClick1(3)}
              >
                {es_un_check_usted(3)}
              </Button>
            </Col>
            <Col className="col-8 d-flex justify-content-start align-items-center">
              <p className="xz-titulo1 ">{_preg.alt3}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const pregunta_matriz = () => {
    return (
      <Row>
        <h5></h5>
        <Col className="col-12 ">
          <p className="">
            <span className="xz-pregunta4">
              Queremos conocer cómo te evalúas en comparación con personas que
              consideres como tus pares o similares a ti en el contexto laboral,
              respecto de ciertos aspectos. Marca en la escala de 7 posiciones,
              la alternativa que mejor te representa:
            </span>
          </p>
        </Col>
        <hr className="mt-3" />
        <Col className="col-12 ">
          <Row>
            <Col className="col-3 xz-texto-instruccion  d-flex justify-content-center">
              Aspecto
            </Col>
            <Col className="d-flex justify-content-center">
              La mayoría es mejor que yo
            </Col>
            <Col className="d-flex justify-content-center">
              Muchos son mejores que yo
            </Col>
            <Col className="d-flex justify-content-center">
              Algunos son mejores que yo
            </Col>
            <Col className="d-flex justify-content-center">
              Yo soy igual al resto
            </Col>
            <Col className="d-flex justify-content-center">
              Yo soy mejor que algunos
            </Col>
            <Col className="d-flex justify-content-center">
              Yo soy mejor que muchos
            </Col>
            <Col className="d-flex justify-content-center">
              Yo soy mejor que la mayoría
            </Col>
          </Row>
          {/* Fila 1 */}
          <Row>
            <Col className="col-3 xz-texto-nota d-flex justify-content-start align-items-center">
              <p>En conocimientos del trabajo</p>
            </Col>
            <Col className="col-9  d-flex justify-content-start align-items-center">
              <Form.Range
                value={values.range01}
                name="range01"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
                className=""
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 2 */}
          <Row>
            <Col className="col-3 xz-texto-nota   d-flex justify-content-start align-items-center">
              <p>En excelencia laboral</p>
            </Col>
            <Col className="col-9  d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range02}
                name="range02"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 3 */}
          <Row>
            <Col className="col-3 xz-texto-nota d-flex justify-content-start align-items-center">
              <p>En calidad en el trabajo realizado</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range03}
                name="range03"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 4 */}
          <Row>
            <Col className="col-3 xz-texto-nota  d-flex justify-content-start align-items-center">
              <p>En inteligencia</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range04}
                name="range04"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 5 */}
          <Row>
            <Col className="col-3 xz-texto-nota d-flex justify-content-start align-items-center">
              <p>En cooperación</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range05}
                name="range05"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 6 */}
          <Row>
            <Col className="col-3 xz-texto-nota  d-flex justify-content-start align-items-center">
              <p>En experiencia valiosa para la Compañía</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range06}
                name="range06"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 7 */}
          <Row>
            <Col className="col-3 xz-texto-nota   d-flex justify-content-start align-items-center">
              <p>En constancia/a</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range07}
                name="range07"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 8 */}
          <Row>
            <Col className="col-3 xz-texto-nota  d-flex justify-content-start align-items-center">
              <p>En capacidad de análisis</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range08}
                name="range08"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 9 */}
          <Row>
            <Col className="col-3 xz-texto-nota   d-flex justify-content-start align-items-center">
              <p>En creatividad</p>
            </Col>
            <Col className="col-9   d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range09}
                name="range09"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
          {/* Fila 10 */}
          <Row>
            <Col className="col-3 xz-texto-nota  d-flex justify-content-start align-items-center">
              <p>En liderazgo</p>
            </Col>
            <Col className="col-9  d-flex justify-content-end align-items-center">
              <Form.Range
                value={values.range10}
                name="range10"
                onChange={handleInputChange}
                min="1"
                max="7"
                step="1"
              ></Form.Range>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const pregunta_final =
    _preg.id_correlativo >= 1 && _preg.id_correlativo <= 3
      ? pregunta_2_alternativa
      : _preg.id_correlativo === 4
      ? pregunta_3_alternativa
      : pregunta_matriz;

  return (
    <Container>
      <Row>
        <Col>
          <h3 className="mt-4 xz-titulo1">
            Pregunta {preguntaActiva.contador} de {_instrumento.total_preguntas}
          </h3>
        </Col>
        <Col>
          <h3 className="mt-4  xz-titulo2 text-end">
            {_instrumento.nombre_instrumento}
          </h3>
        </Col>
      </Row>

      <hr />
      {pregunta_final()}
      <hr className="mt-5" />

      {/* MENSAJE DE ERROR */}
      {errorMsg && (
        <Row className="mb-3">
          <Col>
            <Alert variant="danger">{errorMsg}</Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col className="text-start">
          <span
            className="xz-texto-nota"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={HandleClickVolver}
          >
            Volver al Inicio
          </span>
        </Col>
        <Col>
          <p className="xz-texto-nota ">{avanzar_siguiente()}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Pregunta203;
